<ng-container *transloco="let t">
  @if (displayName() && establishment().name) {
    <div class="info-block">
      <p class="subsidiary__name">{{ establishment().name }}</p>
    </div>
  }
  @if (displayAddress() && address()) {
    <div class="info-block">
      <p class="subsidiary__address">
        {{ address() }}
        @if (addressReferences()) {
          <span class="address-references">
            {{ addressReferences() }}
          </span>
        }
        @if (coordinates()) {
          @if (displayMap()) {
            <div class="establishment-map">
              <a class="map-link ui-item-link" [href]="establishmentMapUrl()" target="_blank">
                <div class="map-container">
                  <pxw-stadia-maps-static
                    [center]="coordinates()"
                    [marker]="coordinates()"
                    [zoom]="15"
                    [width]="400"
                    [height]="400"
                    [objectFit]="'cover'"
                    [alt]="t('shippingOptions.establishmentLocation')"
                  />
                </div>
              </a>
            </div>
          }
          <pxw-button
            appareance="link"
            size="sm"
            color="link"
            [href]="establishmentMapUrl()"
            target="_blank"
          >
            <pxw-icon icon="external-link" />
            {{ t('sideMenu.openInGoogleMaps') }}
          </pxw-button>
        }
      </p>
    </div>
  }
  @if (displayContactInfo() && hasContactInfo()) {
    <div class="info-block">
      @if (establishment().phone) {
        <a
          class="ui-help-link phone-link"
          [href]="whatsappLink()"
          [target]="whatsappLinkHttpTarget"
        >
          <pxw-icon class="whatsapp-icon" icon="whatsapp" size="xs" />
          <span>+{{ establishment().phone }}</span>
        </a>
      }
      @if (establishment().additionalPhone) {
        <a
          class="ui-help-link phone-link"
          href="tel:+{{ establishment().additionalPhone }}"
          target="_blank"
          rel="noopener noreferrer"
        >
          <pxw-icon icon="phone" size="xs" />
          <span>+{{ establishment().additionalPhone }}</span>
        </a>
      }
    </div>
  }
  @if (displayOpenStatus() && workingDaysEnabled()) {
    <div class="info-block">
      <pxw-establishment-opened-status-tag [establishment]="establishment()" />

      @if (!displayWorkingDays()) {
        <pxw-button
          style="margin-top: 1em"
          display="block"
          appareance="link"
          size="sm"
          color="blue"
          (click)="displayWorkingHours($event)"
        >
          {{ t('Ver días y horarios de atención') }}
        </pxw-button>
      }
    </div>
  }
  @if (displayWorkingDays() && workingDaysEnabled()) {
    <div class="info-block">
      <p class="subsidiary__working-hours">
        <pxw-working-hours-message-details [workingDays]="establishment().workingDays" />
      </p>
    </div>
  }
</ng-container>
